import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const key = (user: number) => `gong.pending-launch.${user}`;
export function rememberPendingLaunch(user: number, draft: string) {
  try { localStorage.setItem(key(user), draft); } catch { /* Storage can be disabled in a WebView. */ }
}

export function PendingLaunch({ user, session, onOpen }: { user: number | undefined; session: string | null; onOpen: (curve: string) => void }) {
  const [pending, setPending] = useState(false);
  const [curve, setCurve] = useState<string | null>(null);
  useEffect(() => {
    if (!user || !session) return;
    const controller = new AbortController();
    let running = false;
    async function poll() {
      if (running) return;
      running = true;
      try {
        const draftId = localStorage.getItem(key(user!));
        setPending(Boolean(draftId));
        if (!draftId) return;
        const draft = await api<{ curve_address: string | null }>(`/api/launch-drafts/${encodeURIComponent(draftId)}`, session, undefined, undefined, controller.signal);
        if (!draft.curve_address) return;
        const token = await api<{ minter_address: string | null; phase: string }>(`/api/tokens/${encodeURIComponent(draft.curve_address)}`, null, undefined, undefined, controller.signal);
        if (token.minter_address && token.phase !== 'Initializing') setCurve(draft.curve_address);
      } catch { /* Keep the recovery marker on transient API or storage errors. */ }
      finally { running = false; }
    }
    void poll();
    const timer = window.setInterval(() => void poll(), 5000);
    return () => { controller.abort(); window.clearInterval(timer); };
  }, [user, session]);
  if (!pending) return null;
  return <div className={`banner${curve ? ' ok' : ''}`} role="status">
    {curve ? 'Ваш токен запущен.' : 'Ожидаем подтверждения последнего запуска. Можно закрыть приложение: проверка продолжится при следующем открытии. Если кошелёк показывает ошибку транзакции, запуск не состоялся.'}
    {curve ? <button className="ghost" onClick={() => {
      try { localStorage.removeItem(key(user!)); } catch { /* Best-effort cleanup. */ }
      setPending(false); onOpen(curve);
    }}>Открыть токен →</button> : null}
  </div>;
}
